import React, {useState, useEffect} from "react";
// import { useTable, useSortBy } from "react-table";

import { API_URL, GET_COUNTRIES } from "../../../constants";

import { LoadingSpinner } from "../partials/LoadingSpinner";
import { SelectInput } from "../../Global/SelectInput/SelectInput";

import { UsaTable } from "./VatTables/UsaTable";
import { EuTable } from "./VatTables/EuTable";
import { CaTable } from "./VatTables/CaTable";
import { RestTable } from "./VatTables/RestTable";

import "./AdminVatRates.css";

export const AdminVatRates = () => {
  const [dataLoaded, setDataLoaded] = useState(false);

  const [selectedContinent, setSelectedContinent] = useState({});
  const [selectedState, setSelectedState] = useState({});
  const [countriesList, setCountriesList] = useState([]);
  
  const regions = [
    {
      label: "USA",
      value: 'US'
    },
    {
      label: "Europe",
      value: 'EU'
    },
    {
      label: "Canada",
      value: 'CA'
    },
    {
      label: "Rest of the World",
      value: 'REST'
    },
  ]

  // get countries
  useEffect(() => {
    let convertedCountries = []

    fetch(API_URL + GET_COUNTRIES)
      .then((response) => response.json())
      .then((data) => {
        data.US.map((item) => {
          return convertedCountries = [
            ...convertedCountries, 
            {
              label: item.name,
              value: item.id
            }
          ]
        })
      })
      .then(() => {
        setSelectedState(convertedCountries[0])
        setCountriesList(convertedCountries)
      })
  }, [])

  useEffect(() => {
    setSelectedContinent(regions[0])
    setDataLoaded(true);
  }, [])

  // Table Constructor
  const contentConstructor = () => {
    switch (selectedContinent.value) {
      case 'US': {
        return <UsaTable 
        selectedState={selectedState.value} 
        selectedContinent={selectedContinent.value} />
      }

      case 'EU': {
        return <EuTable 
        selectedContinent={selectedContinent.value} />
      }

      case 'CA': {
        return <CaTable 
        selectedContinent={selectedContinent.value} />
      }

      case 'REST': {
        return <RestTable 
        selectedContinent={selectedContinent.value} />
      }

      default: {
        return <>Error occured. Try Selecting different Continent</>
      }
    }
  }

  return (
    <div className="AdminVatRates">
      <div className="Dashboard__content__top-row">
        <h2>Administrate VAT rates</h2>
      </div>
  
      <div className="header">
        <SelectInput 
          value={selectedContinent}
          selectValues={regions}
          inputValueHandler={(val) => setSelectedContinent(val)}
        />

        {selectedContinent.value === 'US' && 
          <SelectInput 
            value={selectedState}
            selectValues={countriesList}
            inputValueHandler={(val) => setSelectedState(val)}
          />
        }

      </div>

      {dataLoaded === true ? (
        <div className="content">
          {contentConstructor()}
        </div>
      ) : dataLoaded ? (
        <div className="loading">No Data Found</div>
      ) : (
        <LoadingSpinner/>
      )}
    </div>
  );
};
